/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetPaeEstimateItemsDto } from './GetPaeEstimateItemsDto';
import {
    GetPaeEstimateItemsDtoFromJSON,
    GetPaeEstimateItemsDtoFromJSONTyped,
    GetPaeEstimateItemsDtoToJSON,
} from './GetPaeEstimateItemsDto';

/**
 * 
 * @export
 * @interface GetPaeImportDto
 */
export interface GetPaeImportDto {
    /**
     * 
     * @type {string}
     * @memberof GetPaeImportDto
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaeImportDto
     */
    projectNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaeImportDto
     */
    paeUrl: string;
    /**
     * 
     * @type {Array<GetPaeEstimateItemsDto>}
     * @memberof GetPaeImportDto
     */
    positions: Array<GetPaeEstimateItemsDto>;
}

/**
 * Check if a given object implements the GetPaeImportDto interface.
 */
export function instanceOfGetPaeImportDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "projectId" in value;
    isInstance = isInstance && "projectNumber" in value;
    isInstance = isInstance && "paeUrl" in value;
    isInstance = isInstance && "positions" in value;

    return isInstance;
}

export function GetPaeImportDtoFromJSON(json: any): GetPaeImportDto {
    return GetPaeImportDtoFromJSONTyped(json, false);
}

export function GetPaeImportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPaeImportDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectId': json['projectId'],
        'projectNumber': json['projectNumber'],
        'paeUrl': json['paeUrl'],
        'positions': ((json['positions'] as Array<any>).map(GetPaeEstimateItemsDtoFromJSON)),
    };
}

export function GetPaeImportDtoToJSON(value?: GetPaeImportDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectId': value.projectId,
        'projectNumber': value.projectNumber,
        'paeUrl': value.paeUrl,
        'positions': ((value.positions as Array<any>).map(GetPaeEstimateItemsDtoToJSON)),
    };
}

